// Featured boats configuration
// These boats will always appear in search results when sorting by length,
// positioned according to their length, regardless of their sale status.
// Add the yacht IDs here (up to 4 boats)

export const featuredBoatIds = [199, 169, 127, 201];
